import { ValidatorFn, AbstractControl } from '@angular/forms';
import {Injectable} from '@angular/core';

/**
 * Class holding custom SiLA Browser (sb) validators
 *
 * This is the container where validator functinons can be defined
 */
@Injectable()
export class SBValidationService {

    /***
     * Data type validator: used to validate the input of form
     * matches expected data type of model e.g/. Integer, Real
     *
     *
     * param {string} dataType which form value is validated against
     * returns {ValidatorFn} null if validation passes, object with
     * validation information otherwise
     */
    static typeValidator(dataType: string): ValidatorFn {
      return (control: AbstractControl) => {
          if (!control.value) {
              return null;
          }
          if (dataType === 'Integer') {
              if (parseFloat(control.value) !== parseInt(control.value, 10)) {
                  return {dataType: 'Integer', message: 'Please enter an integer'};
              } else if (isNaN(control.value)) {
                  return {dataType: 'Integer', message: 'Please enter a integer'};
              } else {
                  return null;
              }
          } else if (dataType === 'Real') {
              if (isNaN(parseFloat(control.value))) {
                  return {dataType: 'Integer', message: 'Please enter a Real number'};
              } else {
                  return null;
              }
          }
          return null;
      };
    }

    /**
     * Form validator to perform range checking of form input data
     *
     * Note: this additional validator was added although there
     * already exists Angular validators.max() and .min() as this
     * one conversely also returns an error object with a message.
     *
     * function   rangeValidator (name)
     * param      {<type>}  min      The minimum
     * param      {<type>}  max      The maximum
     * param      {<type>}  control  The control
     * return     {<type>}  { description_of_the_return_value }
     */
    static rangeValidator( min: number, max: number): ValidatorFn {
      return (control: AbstractControl) => {
        if (! control.value) {
          return null;
        }
        if (control.value > min  && control.value <= max) {
          return null;
        } else {
          return {outOfRange: true, message: 'Enter a value between ' + min + ' .. ' + max };
        }
      };
    }
}
